var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.50045 8.78077L11.8003 5.48096L12.7431 6.42376L8.50045 10.6664L4.25781 6.42376L5.20063 5.48096L8.50045 8.78077Z",
  fill: "#D44500"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };